"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const coerceValueToBoolean_1 = __importDefault(require("./coerceValueToBoolean"));
const hasFieldMappings_1 = __importDefault(require("./hasFieldMappings"));
function coerceDefaultValue(value) {
    switch (value) {
        case 'yes':
        case 'true':
            return true;
        case 'no':
        case 'false':
            return false;
        default:
            return Boolean(value);
    }
}
function getBooleanValue({ value, defaultValue, shouldFallbackToDefault, }) {
    if (shouldFallbackToDefault && lodash_1.isNil(value) && !lodash_1.isNil(defaultValue)) {
        return coerceDefaultValue(defaultValue);
    }
    if (!shouldFallbackToDefault && lodash_1.isNil(value)) {
        return null;
    }
    return hasFieldMappings_1.default(value) ? value : coerceValueToBoolean_1.default(value);
}
exports.default = getBooleanValue;
